<template>
  <div>
    <PageAllow
      controller="PurchasePlans"
      :action="mode ? mode : 'view'"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                mode == "distribute"
                  ? $t("PurchasePlansDetail.distributeTitle")
                  : $t("CRUD.info", [$t("PurchasePlansDetail.ObjectName")])
              }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="purchase_plans.status | purchasePlansStatusColor"
                :text-color="purchase_plans.status | purchasePlansStatusTextColor"
              >
                {{ purchase_plans.status | purchasePlansStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 保存分配 -->
                <v-btn
                  v-if="
                    mode == 'distribute' &&
                    $permission.permissionAllow('PurchasePlans', 'distribute')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("PurchasePlansDetail.actions.distributeSubmit") }}
                </v-btn>
              </v-sheet>
              <PurchasePlansActions
                v-if="!isDistribute"
                detailMode
                :purchasePlans="purchase_plans"
                :showEdit="purchase_plans.status == 1"
                :showExport="$permission.permissionAllow('PurchasePlans', 'detailExport')"
                :showDistribute="purchase_plans.status == 1"
                :showCancel="$permission.permissionAllow('PurchasePlans', 'cancel')"
                @distribute="mode = 'distribute'"
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 采购计划单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasePlansDetail.Fields.purchase_plan_code")}}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase_plans.purchase_plan_code }}
                </v-card>
              </v-col>
              <!-- 创建者 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasePlansDetail.Fields.creater")}}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase_plans.creater_name }}
                  </span>
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasePlansDetail.Fields.created")}}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase_plans.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 仓库 -->
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasePlansDetail.Fields.stock")}}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase_plans.stock ? purchase_plans.stock.name : "" }}
                </v-card>
              </v-col>
              <!-- 分配任务日期 -->
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasePlansDetail.Fields.distribute_task_date") }}
                    <Required
                      :show="mode == 'distribute' ? true : false"
                      :mode="mode"
                    />
                    {{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    v-if="mode == 'distribute'"
                    class="my-n2"
                    v-model="purchase_plans.distribute_task_date"
                    type="date"
                    single-line
                    dense
                    hide-details
                    disabled-before-today
                  />
                  <span v-else>
                    {{ purchase_plans.distribute_task_date | formatDate }}
                  </span>
                </v-card>
              </v-col>
              <!-- 备注 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasePlansDetail.Fields.memo")}}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="purchase_plans.memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ purchase_plans.memo }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isDistribute">
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                v-if="$permission.permissionAllow('PurchasePlans', 'relations')"
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("PurchasePlans.actions.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-if="$permission.permissionAllow('PurchasePlans', 'relations')"
              >
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.identify_code="{ item }">
                      <a
                        :href="'/#/purchases/detail/' + item.identify_id"
                        style="text-decoration: none"
                        v-if="item.identify == 'purchases'"
                      >
                        {{ item.identify_code }}
                      </a>
                      <a
                        :href="'/#/purchase-tasks/detail/' + item.identify_id"
                        style="text-decoration: none"
                        v-else
                      >
                        {{ item.identify_code }}
                      </a>
                    </template>
                    <template v-slot:item.stock_order_code="{ item }">
                      <a
                        :href="'/#/stock-orders-in/' + item.id"
                        style="text-decoration: none"
                      >
                        {{ item.stock_order_code }}
                      </a>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        v-if="item.stock_order_code"
                        small
                        label
                        class="ms-1"
                        :color="item.status | stockOrderINStatusColor"
                        :text-color="item.status | stockOrderINStatusTextColor"
                        >
                        {{ item.status | stockOrderINStatusText }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <div class="px-4 pb-4">
      <!-- 采购计划单 -->
      <v-card class="px-4" v-if="isView">
        <!-- 采购计划单明细 -->
        <v-data-table
          :headers="detailHeaders"
          :items="purchase_plan_details"
          multi-sort
          disable-pagination
          hide-default-footer
        >
          <!-- 规格 -->
          <template v-slot:item.standard_name="{ item }">
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name ? item.standard_name : "" }}
            </span>
          </template>
          <template v-slot:item.purchase_user="{ item }">
            {{ item.purchase_user ? item.purchase_user.name : "" }}
          </template>
          <template v-slot:item.supplier="{ item }">
            <span>
               {{ item.supplier ? item.supplier.supplier_code + " / " +  item.supplier.supplier_name : "" }}
            </span>
          </template>
        </v-data-table>
      </v-card>
      <!-- 采购计划单分配 -->
      <v-card class="px-4" v-else>
        <!-- 采购计划单 -->
        <v-data-table
          v-if="!preview"
          :headers="detailHeaders"
          :items="purchase_plan_details"
          multi-sort
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.supplier="{ item }">
            <v-autocomplete
              v-model="item.supplier_id"
              :items="suppliers"
              item-text="Description"
              item-value="id"
              :disabled="item.purchase_user_id ? true : false"
              clearable
              @change="clearData(item, 'supplier')"
            />
          </template>
          <template v-slot:item.price="{ item }">
            <v-text-field
              single-line
              dense
              hide-details
              v-model="item.price"
              type="number"
              min="0"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(Number(item.price),2);
              "
              style="max-width: 100px; margin-left: auto"
            >
            </v-text-field>
          </template>
          <template v-slot:item.purchase_user="{ item }">
            <v-autocomplete
              v-model="item.purchase_user_id"
              :items="accountUsers"
              item-text="name"
              item-value="id"
              :disabled="item.supplier_id ? true : false"
              clearable
              @change="clearData(item, 'purchase_user')"
            />
          </template>
          <template v-slot:item.memo="{ item }">
            <v-text-field
              v-model="item.memo"
              single-line
              dense
              hide-details
              style="max-width: 200px"
            >
              <template v-slot:append>
                <v-icon
                  x-small
                  @click.stop="
                    detail_memo_item = {
                      material_code: item.material.material_code,
                      material_name: item.material.material_name,
                      memo: item.memo
                    };
                    memoDialog = true;
                  "
                  class="pt-2 pb-1 primary--text"
                >
                  fa-edit
                </v-icon>
              </template>
            </v-text-field>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import PurchasePlansActions from "./plugins/Actions";
import Required from "@/components/plugins/Required";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import AccountUsers from "@/api/account_users";
import Suppliers from "@/api/suppliers";
import PurchasePlans from "@/api/purchase_plans.js";
import PurchaseUserTasks from "@/api/purchase_user_tasks"

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    PurchasePlansActions,
    Required,
    SearcherDatetime,
  },
  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.purchasePlans"),
          disabled: false,
          href: "/purchase-plans",
        },
        {
          text: i18n.t("PurchasePlansDetail.title"),
          disabled: true,
          href: "/purchase-plans",
        },
      ];
      return items;
    },
    isDistribute() {
      return this.mode == "distribute";
    },
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        !this.preview && (this.mode == "distribute")
      );
    },
    detailHeaders() {
      let headers = [
        {
          text: i18n.t("PurchasePlansDetail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material.material_code",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material.material_name",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.supplier"),
          align: "start",
          sortable: false,
          value: "supplier",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.price"),
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.purchase_user"),
          align: "start",
          sortable: false,
          value: "purchase_user",
        },
        // 采购订货数
        {
          text: i18n.t("PurchasePlansDetail.Fields.quantity"),
          align: "center",
          sortable: false,
          value: "quantity",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.purchase_num"),
          align: "start",
          sortable: false,
          value: "purchase_num",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.in_num"),
          align: "start",
          sortable: false,
          value: "in_num",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.unit"),
          align: "center",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("PurchasePlansDetail.Fields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        }
      ];
      return headers;
    },
    relationsHeaders: () => [
      {
        text: i18n.t("PurchasePlans.RelationFields.identify_name"),
        align: "center",
        sortable: false,
        value: "identify_name",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.identify_code"),
        align: "center",
        sortable: false,
        value: "identify_code",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.stock_order"),
        align: "center",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("PurchasePlans.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
    ],
    ...mapState(["settings", "accountUser", "accountInfo"]),
  },

  data: () => ({
    panels: [0],
    panelsDetail: [0],
    DetailTab: null,
    mode: "",
    purchase_plans: {},
    purchase_plan_details: [],
    detail_memo_item: { memo: "" },
    accountUsers: [],
    suppliers: [],
    memoDialog: false,
    preview: false,
    tab: null,
    relations: []
  }),

  mounted() {
      this.mode = this.$route.params.mode;
      if (this.mode) {
        this.$router.replace("/purchase-plans/detail/" + this.$route.params.id);
      }
  },

  methods: {
    getPurchasePlansDetailsFromAPI() {
      let postData = {
        order_activity: 1,
      }
      let id = this.$route.params.id;
      if (this.isDistribute) {
        AccountUsers.fetchAll({type: [2]}).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.accountUsers = response.data.account_users;
            }
          }.bind(this)
        )
        Suppliers.fetchAllForSelect({}).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.suppliers = response.data.suppliers.map((supplier) => {
                const Description = supplier.supplier_code + " / " + supplier.supplier_name;
                return Object.assign({}, supplier, { Description });
              });
            }
          }.bind(this)
        )
        postData.distribute_flg = 1;
      }
      if (this.$route.params.id.charAt(0) == 'J') {
        // 兼容单号获取明细
        postData.purchase_plan_code = this.$route.params.id
        id = '';
      }
      PurchasePlans.fetchOne(id, postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase_plans = response.data.purchase_plan;
            this.purchase_plan_details = response.data.purchase_plan.purchase_plan_details
            if (this.isDistribute) {
              this.purchase_plans.distribute_task_date = new Date().toISOString().substr(0, 10);
              PurchaseUserTasks.getUserCategories({stock_id: this.purchase_plans.stock_id}).then(
                function (categoriesResponse) {
                  if (response.data.status.isOK()) {
                    this.purchase_plan_details.forEach((detail) => {
                       if (categoriesResponse.data.materials[detail.material_id]) {
                        detail.purchase_user_id = categoriesResponse.data.materials[detail.material_id] ? categoriesResponse.data.materials[detail.material_id] : ''
                      } else {
                         if (detail.default_supplier) {
                           detail.supplier_id = detail.default_supplier.supplier_id ? detail.default_supplier.supplier_id : null
                           detail.price = detail.default_supplier.plan_detail_price ? detail.default_supplier.plan_detail_price : 0
                         }
                       }
                    })
                  }
                }.bind(this)
              )
            }
            this.getRelations()
          }
        }.bind(this)
      );
    },
    getRelations() {
      let id = this.$route.params.id;
      let postData = {}
      if (this.$route.params.id.charAt(0) == 'J') {
        // 兼容单号获取明细
        postData.purchase_plan_code = this.$route.params.id
        id = '';
      }
      PurchasePlans.fetchRelations(id, postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.relations = [];
            response.data.stock_orders.forEach((stock_order, index) => {
              this.relations.push(
                Object.assign(
                  {
                    index: index,
                    identify: "stock_orders_in",
                    identify_name: i18n.t("PurchasePlans.RelationFields.stock_orders_in"),
                    stock_order_code: stock_order.stock_order_code,
                  }, stock_order)
              );
            });
            response.data.purchase_tasks.forEach((purchase_tasks, index) => {
              if (purchase_tasks.stock_orders.length > 0) {
                purchase_tasks.stock_orders.forEach((stock_order) => {
                  this.relations.push(
                    Object.assign(
                      {
                        index: index,
                        identify: "purchase_tasks",
                        identify_name:  i18n.t("PurchasePlans.RelationFields.purchase_tasks"),
                        identify_id: purchase_tasks.id,
                        identify_code: stock_order.purchase_task_code,
                        stock_order_code: stock_order.stock_order_code
                      }, stock_order)
                  );
                })
              }else {
                this.relations.push(
                  Object.assign(
                    {
                      index: index,
                      identify: "purchase_tasks",
                      identify_name:  i18n.t("PurchasePlans.RelationFields.purchase_tasks"),
                      identify_id: purchase_tasks.id,
                      identify_code: purchase_tasks.purchase_task_code,
                    }, purchase_tasks)
                );
              }
            });
            if (this.purchase_plans.purchases && this.purchase_plans.purchases.length > 0) {
              this.purchase_plans.purchases.forEach((purchase, index) => {
                this.relations.push(
                  Object.assign(
                    {
                      index: index,
                      identify: "purchases",
                      identify_name:  i18n.t("PurchasePlans.RelationFields.purchases"),
                      identify_id: purchase.id,
                      identify_code: purchase.purchase_code,
                      stock_order_code: ""
                    }, purchase)
                );
              })
            }
          }
        }.bind(this)
      );
    },
    //整理预览提交数据
    doSubmitData() {
      let purchasePlans = {
        id: this.purchase_plans.id,
        distribute_task_date: this.purchase_plans.distribute_task_date,
        memo: this.purchase_plans.memo,
        purchase_plan_details: []
      };
      if (this.purchase_plan_details) {
        this.purchase_plan_details.forEach((detail) => {
          purchasePlans.purchase_plan_details.push({
            id: detail.id,
            supplier_id: detail.supplier_id ? detail.supplier_id : null,
            price: detail.price,
            quantity: detail.quantity,
            purchase_user_id: detail.purchase_user_id ? detail.purchase_user_id : null,
            memo: detail.memo
          })
        })
      }
      return purchasePlans;
    },

    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      PurchasePlans.distribute(this.doSubmitData()).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/purchase-plans");
            this.$store.dispatch("fullscreenLoadingStop");
          }else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
         }.bind(this)
      )
      .catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    clearData(data, type){
      this.purchase_plan_details.forEach((detail) => {
        if (data.id == detail.id) {
          if (type == 'supplier') {
            detail.purchase_user_id = null;
          }else if (type == 'purchase_user') {
            detail.supplier_id = null;
          }
        }
      })
    }
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/purchase-plans/detail/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getPurchasePlansDetailsFromAPI();
        }
      },
    },
  },
};
</script>